<template lang="pug">
  transition(name="slide-up" appear)
    .invoice-selection-actions(v-if="show")
      .actions-container
        .selection-info
          .yz-regular-body-sm {{ selectedItems.length }} {{ $t('panel.items') }} {{ $t('panel.selected').toLowerCase() }}
        .actions-group
          yz-tooltip(:text="downloadInvoiceTooltipText" :disabled="!isDownloadInvoiceDisabled")
            yz-btn(:label="$t('panel.download_invoice')" size="lg" :disabled="isDownloadInvoiceDisabled" @click="onDownloadInvoice")
          yz-tooltip(:text="downloadReceiptTooltipText" :disabled="!isDownloadReceiptDisabled")
            yz-btn(:label="$t('panel.download_receipt')" size="lg" :disabled="isDownloadReceiptDisabled" @click="onDownloadReceipt")
          yz-tooltip(:text="bulkClaimTooltipText" :disabled="!isBulkClaimDisabled")
            yz-btn(:label="$t('panel.create_bulk_panel_claim')" size="lg" :disabled="isBulkClaimDisabled" @click="onCreateBulkClaim")
</template>

<script>
export default {
  props: {
    selectedItems: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      downloadLimit: 20
    }
  },
  computed: {
    isDownloadInvoiceDisabled() {
      return this.selectedItems.length > this.downloadLimit
    },
    isDownloadReceiptDisabled() {
      return this.selectedItems.length > this.downloadLimit
    },
    downloadInvoiceTooltipText() {
      if (this.selectedItems.length > this.downloadLimit) {
        return this.$t('panel.download_limit_exceeded')
      }
      return ''
    },
    downloadReceiptTooltipText() {
      if (this.selectedItems.length > this.downloadLimit) {
        return this.$t('panel.download_limit_exceeded')
      }
      return ''
    },
    isBulkClaimDisabled() {
      if (this.selectedItems.length <= 1) {
        return true
      }
      const firstPanelId = this.selectedItems[0].panel?.id
      return this.selectedItems.some(item => item.panel?.id !== firstPanelId)
    },
    bulkClaimTooltipText() {
      if (this.selectedItems.length <= 1) {
        return this.$t('panel.select_at_least_2_invoices')
      }
      const firstPanelId = this.selectedItems[0].panel?.id
      const hasMixedPanels = this.selectedItems.some(item => item.panel?.id !== firstPanelId)
      if (hasMixedPanels) {
        return this.$t('panel.all_invoices_same_panel')
      }
      return ''
    }
  },
  methods: {
    onDownloadInvoice() {
      this.$emit('download-invoice', this.selectedItems)
    },
    onDownloadReceipt() {
      this.$emit('download-receipt', this.selectedItems)
    },
    onCreateBulkClaim() {
      this.$emit('create-bulk-claim', this.selectedItems)
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-selection-actions {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  background-color: white;
  padding: 12px 16px;
  box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.2);
  z-index: 100;
  border-radius: 10px;
  max-width: 700px;
  margin: 0 auto;
  border-bottom: 3px solid #000000;
}

.actions-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.actions-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

// Transition animations
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-enter-to,
.slide-up-leave {
  transform: translateY(0);
  opacity: 1;
}

// Responsive design
@media (max-width: 768px) {
  .invoice-selection-actions {
    padding: 12px 16px;
  }

  .actions-container {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .selection-info {
    text-align: center;
  }

  .actions-group {
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .actions-group {
    flex-direction: column;
    gap: 8px;
  }
}
</style>